import styled from "styled-components";

import { SetupProjectPanel } from "@pages/setup/components/SetupProjectPanel";

const PurpleContainer = styled.div`
  background-color: var(--indigo7);
  border-radius: 3px;
  box-shadow: 0px 1px 1px rgba(16, 22, 26, 0.2),
    0px 0px 0px 1px rgba(16, 22, 26, 0.1);
`;

export const NoProjectZeroState: React.FC = () => {
  return (
    <PurpleContainer>
      <SetupProjectPanel />
    </PurpleContainer>
  );
};
